import styled, { css } from 'styled-components';
import React from 'react';
import { ReactComponent as Question } from '@icons/question.svg';
import { ReactComponent as Info } from '@icons/notification_info.svg';
import { ReactComponent as Warning } from '@icons/notification_warning.svg';
import { ReactComponent as Error } from '@icons/notification_error.svg';
import { ReactComponent as Success } from '@icons/notification_success.svg';

import { EColorScheme } from '@/redux/css';
import breakpoints, { zIndexes } from '@styles/constants.styled';
import { ReactComponent as Cross } from '@icons/cross.svg';

const StyledQuestionContainer = styled.div`
  padding: 12px 2px;
  background: #ee765f;
  clip-path: polygon(0 0, 100% 0%, 88% 100%, 0% 100%);
  display: flex;
  align-items: center;
`;
const StyledInfoIconContainer = styled.div`
  padding: 12px 20px;
  background: #033E8C;
  clip-path: polygon(0 0, 100% 0%, 88% 100%, 0% 100%);
  display: flex;
  align-items: center;
`;
const StyledWarningIconContainer = styled.div`
  padding: 12px 20px;
  background: #FF785C;
  clip-path: polygon(0 0, 100% 0%, 88% 100%, 0% 100%);
  display: flex;
  align-items: center;
`;
const StyledErrorIconContainer = styled.div`
  padding: 12px 20px;
  background: #EB2E31;
  clip-path: polygon(0 0, 100% 0%, 88% 100%, 0% 100%);
  display: flex;
  align-items: center;
`;
const StyledSuccessIconContainer = styled.div`
  padding: 12px 20px;
  background: #8BC446;
  clip-path: polygon(0 0, 100% 0%, 88% 100%, 0% 100%);
  display: flex;
  align-items: center;
`;
const StyledQuestionMark = styled(Question)``;
const StyledInfoIcon = styled(Info)``;
const StyledWarningIcon = styled(Warning)``;
const StyledErrorIcon = styled(Error)``;
const StyledSuccessIcon = styled(Success)``;


export const StyledTextContainer = styled.div`
  width: 100%;
  margin: auto;
  padding: 10px 10px 10px 20px;
`;
export const StyledCross = styled(Cross)`
  width: 45px;
  height: 45px;
  cursor: pointer;
  position: relative;
  right: 10px;
  margin: auto;
  * {
    fill: var(--theme-cross-color);
  }
`;
export const StyledContainer = styled.section`
  border-radius: 10px;
  transition: all 300ms ease-out;
  background: var(--theme-main-color);
  display: flex;
  overflow: hidden;

  p {

    font-family: 'Montserrat', sans-serif;
    font-style: italic;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: var(--theme-main-color-inverse);
    transition: all 300ms ease-out;
  }
  
  @media screen and ${breakpoints.Device.mobile} {
    //margin-top: -50px;
    //width: 350px;
  }
  @keyframes fadeOut {
    from {opacity: 1;}
    to {opacity: 0; display: none;}
}
`;
export const StyledContainerError = styled.section`
  border-radius: 10px;
  transition: all 300ms ease-out;
  background: var(--theme-main-color);
  display: flex;
  overflow: hidden;

  p {

    font-family: 'Montserrat', sans-serif;
    font-style: italic;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: var(--theme-text-color);
    transition: all 300ms ease-out;
  }
  
  @media screen and ${breakpoints.Device.mobile} {
    //margin-top: -50px;
    //width: 350px;
  }
  @keyframes fadeOut {
    from {opacity: 1;}
    to {opacity: 0; display: none;}
}
`;

export function StyledBadge(): JSX.Element {
  return (
    <StyledQuestionContainer>
      <StyledQuestionMark />
    </StyledQuestionContainer>
  );
}
export function StyledBadgeInfo(): JSX.Element {
  return (
    <StyledInfoIconContainer>
      <StyledInfoIcon />
    </StyledInfoIconContainer>
  );
}
export function StyledBadgeWarning(): JSX.Element {
  return (
    <StyledWarningIconContainer>
      <StyledWarningIcon />
    </StyledWarningIconContainer>
  );
}
export function StyledBadgeError(): JSX.Element {
  return (
    <StyledErrorIconContainer>
      <StyledErrorIcon />
    </StyledErrorIconContainer>
  );
}
export function StyledBadgeSuccess(): JSX.Element {
  return (
    <StyledSuccessIconContainer>
      <StyledSuccessIcon />
    </StyledSuccessIconContainer>
  );
}

export const StyledNotificationBarTheme = css`
  &[data-theme='${EColorScheme.DAY}'] {
    ${StyledContainer} {
      --theme-main-color: #edeef2;
    }
    ${StyledContainerError} {
      --theme-main-color: #fdeeee;
      --theme-text-color: #eb2e31;
    }
    ${StyledCross} {
      --theme-cross-color: #babccc;
    }
  }

  &[data-theme='${EColorScheme.NIGHT}'] {
    ${StyledContainer} {
      --theme-main-color: #2c2f61;
    }
    ${StyledContainerError} {
      --theme-main-color: #E17573;
      --theme-text-color: #ffffff;
    }
    ${StyledCross} {
      --theme-cross-color: #626489;
    }
  }
`;
